import PlainListComboBox from "../src/plain/PlainListComboBox.js";
export default class ElixListComboBox extends PlainListComboBox {}
customElements.define("elix-list-combo-box", ElixListComboBox);
